var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "DropdownTable",
        [
          _c(
            "o-dropdown-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.status,
                  expression: "status",
                },
              ],
              attrs: { "aria-role": "listitem" },
              on: { click: _vm.handleVisibilityModalEdit },
            },
            [_vm._v(" " + _vm._s(_vm.$t("driver.edit")) + " ")]
          ),
          _c(
            "o-dropdown-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.status,
                  expression: "status",
                },
              ],
              attrs: { "aria-role": "listitem" },
              on: { click: _vm.handleVisibilityModalDelete },
            },
            [_vm._v(" " + _vm._s(_vm.$t("driver.delete")) + " ")]
          ),
          _c(
            "o-dropdown-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.status,
                  expression: "!status",
                },
              ],
              attrs: { "aria-role": "listitem" },
              on: { click: _vm.handleVisibilityModalRestore },
            },
            [_vm._v(" " + _vm._s(_vm.$t("driver.restore")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "o-modal",
        {
          attrs: { active: _vm.isOpenModalEdit, width: "560" },
          on: { close: _vm.handleVisibilityModalEdit },
        },
        [
          _c("div", [
            _c("h2", { staticClass: "header-2" }, [
              _vm._v(_vm._s(_vm.$t("driver.modalEditTitle"))),
            ]),
            _c("p", { staticClass: "paragraph" }, [
              _vm._v(_vm._s(_vm.$t("driver.modalEditParagraph"))),
            ]),
          ]),
          _c("FormEditDriver", {
            attrs: {
              driver: _vm.row,
              "close-modal": _vm.handleVisibilityModalEdit,
            },
          }),
        ],
        1
      ),
      _c(
        "o-modal",
        {
          attrs: { active: _vm.isOpenModalDelete, width: "560" },
          on: { close: _vm.handleVisibilityModalDelete },
        },
        [
          _c("div", [
            _c("h2", { staticClass: "header-2" }, [
              _vm._v(_vm._s(_vm.$t("driver.modalDeleteTitle"))),
            ]),
            _c("p", { staticClass: "paragraph" }, [
              _vm._v(_vm._s(_vm.$t("driver.modalDeleteParagraph"))),
            ]),
          ]),
          _c("FormDeleteDriver", {
            attrs: {
              "driver-id": _vm.row.id,
              "close-modal": _vm.handleVisibilityModalDelete,
            },
          }),
        ],
        1
      ),
      _c("Alert", {
        attrs: { active: _vm.isOpenModalRestore },
        on: { handleClose: _vm.handleVisibilityModalRestore },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.$t("driver.modalRestoreTitle")) + " "),
              ]
            },
            proxy: true,
          },
          {
            key: "message",
            fn: function () {
              return [
                _vm._v(
                  " " + _vm._s(_vm.$t("driver.modalRestoreParagraph")) + " "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "buttons",
            fn: function () {
              return [
                _c(
                  "o-button",
                  {
                    attrs: { variant: "outline", size: "md" },
                    on: { click: _vm.handleVisibilityModalRestore },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("driver.modalButtonCancel")) + " "
                    ),
                  ]
                ),
                _c(
                  "o-button",
                  {
                    attrs: { variant: "primary", size: "md" },
                    on: { click: _vm.handleRestore },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("driver.modalButtonRestore")) + " "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }